import { buildEntityDetailHref } from '@/lib/entity-id'

export function resolveNotificationLink(notification: any): string {
  const relatedId = notification?.relatedId
  const relatedType = String(notification?.relatedType || '').toLowerCase()
  const type = String(notification?.type || '').toLowerCase()

  // Prefer explicit action URL only when it points to a concrete destination.
  if (notification?.actionUrl && typeof notification.actionUrl === 'string') {
    const actionUrl = notification.actionUrl.trim()
    const actionHasTaskId = /\/tasks\/detail\/?\?(?:.*&)?(?:id|task_id|taskId)=[^&]+/i.test(actionUrl)
    const actionHasBugId = /\/bugs\/detail\/?\?(?:.*&)?(?:id|bug_id|bugId)=[^&]+/i.test(actionUrl)
    const actionHasProjectId = /\/projects\/detail\/?\?(?:.*&)?(?:id|project_id|projectId)=[^&]+/i.test(actionUrl)
    const actionHasMilestoneId = /\/milestones\/detail\/?\?(?:.*&)?(?:id|milestone_id|milestoneId)=[^&]+/i.test(actionUrl)
    const actionIsGenericDetail = /\/(tasks|bugs|projects|milestones)\/detail\/?(?:\?|$)/i.test(actionUrl)
    if (!actionIsGenericDetail || actionHasTaskId || actionHasBugId || actionHasProjectId || actionHasMilestoneId) {
      return actionUrl
    }
  }

  if (relatedId && (relatedType === 'task' || type.includes('task'))) {
    return buildEntityDetailHref({ id: relatedId }, 'task') || '/tasks'
  }
  if (relatedId && (relatedType === 'bug' || type.includes('bug'))) {
    return buildEntityDetailHref({ id: relatedId }, 'bug') || '/bugs'
  }
  if (relatedId && (relatedType === 'ticket' || type.includes('ticket'))) {
    return `/tickets?highlight=${encodeURIComponent(String(relatedId))}`
  }
  if (relatedId && relatedType === 'project') {
    return buildEntityDetailHref({ id: relatedId }, 'project') || '/projects'
  }
  if (relatedId && relatedType === 'milestone') {
    return buildEntityDetailHref({ id: relatedId }, 'milestone') || '/milestones'
  }

  if (type.includes('ticket')) return '/tickets'
  if (type.includes('task')) return '/tasks'
  if (type.includes('bug')) return '/bugs'
  if (type.includes('timesheet')) return '/time-tracking'

  return '/notifications'
}
